<gl-base-modal (closeModal)="close(false)">
  <h2>{{ "delete_overlap_header" | translate }}</h2>
  <form [formGroup]="form" class="form">
    <gl-checkbox
      formControlName="dontShowAgain"
      [defaultChecked]="false"
    >{{ 'dont_show_again' | translate }}</gl-checkbox>
  </form>
  <div class="buttons center">
    <button normal-outline-button (click)="close(true)">{{'yes' | translate}}</button>
    <button outline-button (click)="close(false)">{{'no' | translate}}</button>
  </div>
</gl-base-modal>
